/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import LoadingOverlay from './LoadingOverlay'

export default compose<any, any>(
  lifecycle<any, any>({
    componentDidMount () {
      document.body.style.overflow = 'hidden'
    },
    componentWillUnmount () {
      document.body.style.overflow = 'auto'
    },
  }),
)(LoadingOverlay)
